import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { InfoCard } from 'components/InfoCard';

import { history } from 'lib/history';
import { Color } from 'shared/src/modules/styles/colors';

import { RootState } from 'store/types';
import { Consumer } from 'store/profile/types';
import { profileConsumerSelector } from 'store/profile/selectors';

import useNavigationAnalytics from 'hooks/useNavigationAnalytics';
import { AnalyticsEvent } from 'services/AnalyticsService';
import { convertToLowerKabobCase } from 'modules/utils/StringUtils';

export interface HealthToolCardData {
  description: string;
  path: string;
  thumb: string;
}

export interface HealthToolCardProps {
  toolData: HealthToolCardData;
  userProfile: Consumer;
}

const ImgToolContainer = styled.img`
  width: 100%;
`;

const DescriptionTool = styled.p`
  color: ${Color.tealOriginal};
  font-weight: 550;
  font-size: 1.2rem;
  height: 100px;
  margin: 0.8rem;
  overflow-y: auto;
`;

function HealthToolCard({ toolData, userProfile }: HealthToolCardProps) {
  const vyncaCardClicked = useNavigationAnalytics(AnalyticsEvent.VyncaDashboardSelected, {
    title: 'Health Tools Landing Page',
    vendor: 'Vynca'
  });
  const myStrengthCardClicked = useNavigationAnalytics(AnalyticsEvent.MyStrengthDashboardSelected, {
    title: 'Health Tools Landing Page',
    vendor: 'myStrength'
  });

  const preventDiabetesCardClicked = useNavigationAnalytics(
    AnalyticsEvent.PreventDiabetesDashboardClicked,
    {
      title: 'Health Tools Landing Page',
      age: userProfile?.age,
      gender: userProfile?.gender
    }
  );

  // Todo: refactor this, we need to implement a parameter in the tool data with this validations.
  const redirectHealthTool = () => {
    if (toolData.path === '/u/health-tools/vynca') {
      vyncaCardClicked();
      history.push(toolData.path);
    } else if (toolData.path === '/u/health-tools/mystrength') {
      myStrengthCardClicked();
      history.push(toolData.path);
    } else if (toolData.path === '/u/health-tools/prevent-diabetes') {
      preventDiabetesCardClicked();
      history.push(toolData.path);
    } else {
      history.push(toolData.path);
    }
  };

  return (
    <InfoCard onClick={redirectHealthTool} testID={convertToLowerKabobCase(toolData.description)}>
      <ImgToolContainer alt={toolData.description} src={toolData.thumb} />
      <DescriptionTool>{toolData.description}</DescriptionTool>
    </InfoCard>
  );
}

const mapStateToProps = (state: RootState) => ({
  userProfile: profileConsumerSelector(state)
});

export default connect(mapStateToProps)(HealthToolCard);
